export default "__VITE_ASSET__CFfTgrfF__"